export default __webpack_public_path__ + "static/media/icon-chevron-arrow-down.c53f8f84.svg";